import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { get } from '@/utils/api';

const POLL_MS = 60000;

/**
 * True when the given child has a released Core Skills lesson they haven't
 * completed yet. Polls every minute, refetches on window focus and on route
 * change (so a pre-quiz pass that releases the next skill shows up at once).
 */
export default function useCoreSkillsPendingRelease(childId) {
  const [pending, setPending] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!childId) {
      setPending(false);
      return undefined;
    }

    let mounted = true;

    const fetchPending = async () => {
      try {
        const res = await get(`/topics/core-skills/current/${childId}`);
        if (!mounted) return;
        setPending(Boolean(res?.hasPendingRelease));
      } catch {
        // Keep the last known value; a transient failure shouldn't flicker the dot.
      }
    };

    fetchPending();
    const interval = setInterval(fetchPending, POLL_MS);
    window.addEventListener('focus', fetchPending);
    return () => {
      mounted = false;
      clearInterval(interval);
      window.removeEventListener('focus', fetchPending);
    };
  }, [childId, location.pathname]);

  return pending;
}
